import logo from "./logo.svg";
import "./App.css";
import Comingsoon from "./components/Comingsoon";
function App() {
  return <>
  <Comingsoon/>
  </>;
}

export default App;
